module.exports = __webpack_public_path__ + "media/dashboard/assets/images/channels/google-32f8033a025b9e3af9009183899f33d6.png";